import {
  getPromotionList
} from "$shareStore/apis/gateway-web/store";
export default {
    data() {
      return {
        deliveryFee: '',
        originFee: '',
        promotionObj: {
          discountTitle: "",
          bestTitle: "",
          FullReductionDesc: "",
          storeFirstDesc: "",
          storeCouponDesc: "",
          fullReductionActivityNo: "",
          storeFirstActivityNo: "",
        }
      }
    },
    methods: {
        ajaxGetPromotionList() {
          if (
            this?.locationQuery?.storeNo &&
            this?.locationQuery?.lon &&
            this?.locationQuery?.lat
          ) {
            getPromotionList(
              {
                storeNo: this?.locationQuery?.storeNo,
                geo: {
                  lon: this?.locationQuery?.lon,
                  lat: this?.locationQuery?.lat
                }
              },
              {
                success: res => {
                  console.log("promotionlist -> res", res);
                  const {
                    bestSaleItems,
                    productDiscountItems,
                    storeCouponItems,
                    fullReductionItems,
                    deliveryFeeItems,
                    storeFirstItems
                  } = res;
                  // 处理配送费
                  if(deliveryFeeItems.length) {
                    this.handleDeliveryFee(deliveryFeeItems)
                  }
                  // 处理商品优惠活动
                  if (productDiscountItems.length) {
                    this.handleDiscount(productDiscountItems);
                  }
                   // 处理爆品活动
                   if (bestSaleItems.length) {
                    this.handleBest(bestSaleItems);
                  }
                  // 处理优惠券
                  if (storeCouponItems.length) {
                    this.handleCoupon(storeCouponItems);
                  }
                  // 处理满减
                  if (fullReductionItems.length) {
                    this.handleFullReduction(fullReductionItems);
                  }
                  // 处理首单
                  if (storeFirstItems.length) {
                    this.handleStoreFirst(storeFirstItems);
                  }
                  Vue.filter("loading")(false);
                },
                fail: res => {
                  Vue.filter("loading")(false);
                }
              }
            ).finally(() => {
              Vue.filter("loading")(false);
            });
          }
        },
        handleDeliveryFee(item) {
          const {deliveryFeeAfterDiscount={amount: 0}} = item[0]
          this.$nextTick(()=> {
            this.deliveryFee = deliveryFeeAfterDiscount.amount > 0 ? `$${deliveryFeeAfterDiscount.amount}` : this.$t("home.FreeDelivery")
            console.log("进入活动计算配送费",this.deliveryFee)
          })
        },
        handleDiscount(pro) {
          let str = "";
          let that = this;
          let newPro = [];
          let max = 0;
          if (pro.length) {
            pro.forEach(pitem => {
              let title =
                that.lang == "zh"
                  ? pitem.activityTitleZh
                  : that.lang == "km"
                  ? pitem.activityTitleCb
                  : pitem.activityTitleEn;
              // 按照创建时间倒序排序
              if (pitem.createTime > max) {
                max = pitem.createTime;
                newPro.unshift(title);
              } else {
                newPro.push(title);
              }
            });
          }
          console.log("newPro", newPro);
          str = newPro.join(" ");
          this.$set(this.promotionObj, "discountTitle", str);
        },
        handleBest(best) {
          let str = "";
          let that = this;
          let newPro = [];
          if (best.length) {
            best.forEach(bitem => {
              let btitle =
                that.lang == "zh"
                  ? bitem.activityTitleZh
                  : that.lang == "km"
                  ? bitem.activityTitleCb
                  : bitem.activityTitleEn;
              newPro.push(btitle);
            });
          }
          str = newPro.join(" ");
          this.$set(this.promotionObj, "bestTitle", str);
        },
        // 优惠券活动
        handleCoupon(coupon) {
          let newCouponArr = []
          let max = 0
          coupon.forEach(citem => {
            let desc = this.getCouponTitle(citem.faceValue.amount)
            if(citem.faceValue.amount > max)  {
              max = citem.faceValue.amount
              newCouponArr.unshift(desc)
            }else {
              newCouponArr.push(desc)
            }
          })
          let str = newCouponArr.join(' ')
          this.$set(
            this.promotionObj,
            "storeCouponDesc",
            str
          );
        },
        handleStoreFirst(storeFirst) {
          let storeFirstActivity = storeFirst[0]
          let str = this.getFirstOrderTitle(storeFirstActivity.discountAmt.amount)
          this.$set(
            this.promotionObj,
            "storeFirstActivityNo",
            storeFirstActivity.activityNo
          );
          this.$set(
            this.promotionObj,
            "storeFirstDesc",
            str
          );
        },
        // 满减活动  - 门槛越低越靠前
        handleFullReduction(full) {
          let fullActivity = full[0];
          let newFullArr = []
          let min = fullActivity.thresholdAmt.amount
          let str = ''
          full.forEach(fitem => {
            let fullDesc = this.getFullReductionTitle(
              fitem.thresholdAmt.amount,
              fitem.discountAmt.amount
            );
            if(fitem.thresholdAmt.amount < min) {
              min = fitem.thresholdAmt.amount
              newFullArr.unshift(fullDesc)
            }else {
              newFullArr.push(fullDesc)
            }
          })
          console.log('newfull',newFullArr)
          str = newFullArr.join(' ')
          this.$set(
            this.promotionObj,
            "fullReductionActivityNo",
            fullActivity.activityNo
          );
          this.$set(
            this.promotionObj,
            "FullReductionDesc",
            str
          );
        },
        getFirstOrderTitle(count) {
            if (this.lang === 'zh') {
              return `首单立减$${count}`
            }
            if (this.lang === 'km') {
              return `ទទួលបាន${count}$ក្នុងការបញ្ជាទិញដំបូង`
            }
            return `$${count} Off 1st Order`
        },
        getFullReductionTitle(m, j) {
            if (this.lang === 'zh') {
              return `满$${m}减$${j}`
            }
            if (this.lang === 'km') {
              return `ទិញ$${m}បញ្ចុះតម្លៃ $${j}`
            }
            return `Buy $${m} Discount $${j}`
        },
        getCouponTitle(count) {
          if (this.lang === 'zh') {
            return `领$${count}优惠券`
          }
          if (this.lang === 'km') {
            return `ទទួលបាន $${count} គូប៉ុង`
          }
          return `Get $${count} off coupon`
      },
    }
}